import React from 'react';
import { HiOutlineSun, HiOutlineMoon } from 'react-icons/hi';
import { useTheme } from '../context/ThemeContext';

function ThemeToggle() {
  // Proteção contra erro durante hot-reload
  let theme, toggleTheme;

  try {
    const themeContext = useTheme();
    theme = themeContext.theme;
    toggleTheme = themeContext.toggleTheme;
  } catch (error) {
    // Se ThemeProvider não estiver disponível, usa tema padrão
    console.warn('ThemeProvider not available, using default theme');
    theme = document.documentElement.getAttribute('data-theme') || 'light';
    toggleTheme = () => {
      console.warn('ThemeProvider not available, cannot toggle theme');
    };
  }

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={theme === 'light' ? 'Mudar para tema escuro' : 'Mudar para tema claro'}
      title={theme === 'light' ? 'Tema escuro' : 'Tema claro'}
    >
      {theme === 'light' ? (
        <HiOutlineMoon size={20} />
      ) : (
        <HiOutlineSun size={20} />
      )}
    </button>
  );
}

export default ThemeToggle;
